// Material
import { Skeleton, Typography, TypographyProps } from '@mui/material'
import { StatusType } from '@weblite/ts-action/user'
// Logic
import { useUserStatus } from '$logic/users'
// Localization
import { t } from '$i18n'
import { LanguageType } from '$setup/local-language/type'
import { lastSeenAt } from './user-status.helper'

interface Props {
  userId?: string
  textColor?: TypographyProps['color']
  className?: string // TODO: after reviewing merges before this review this component
}

const statusToI18nMapper: Record<
  StatusType,
  keyof LanguageType['user']['status']
> = {
  A_LONG_TIME_AGO: 'aLongTimeAgo',
  WITHIN_A_MONTH: 'withinAMonth',
  WITHIN_A_WEEK: 'withinAWeek',
  ONLINE: 'online',
  RECENTLY: 'recently',
}

export function UserStatus({ className, userId, textColor }: Props) {
  const status = useUserStatus(userId)

  if (!status) return <Skeleton variant="text" width="60%" />

  const statusText =
    typeof status === 'string'
      ? t(`user.status.${statusToI18nMapper[status]}`)
      : lastSeenAt(status)

  return (
    <Typography
      variant="body2"
      sx={{ color: textColor || 'neutral600' }} // TODO: use theme
      className={className}
    >
      {statusText}
    </Typography>
  )
}
